import React, { useCallback, useState } from 'react';
import { Element } from 'react-scroll';
import { useFormContext } from 'react-hook-form';
import Icon from '@common/assets';
import styles from '@components/join/join.module.scss';
import AgreeListItem from '@components/join/agree/AgreeListItem';
import AgreeMarketingListItem from '@components/join/agree/AgreeMarketingListItem';
import { valueNotRequired } from '@utils/validators/validators';
import { RouteUrl } from '@utils/routeUtil';
import { ERROR_TEXT } from '@utils/validators/text';
import classnames from 'classnames/bind';
const cx = classnames.bind(styles);

const Agree = () => {
  const {
    register,
    watch,
    formState: { errors },
    setValue,
    clearErrors,
  } = useFormContext();

  // 개인정보 동의 관련
  const agreeTermsOfServiceYn = watch('agreeTermsOfServiceYn', false);
  const agreePrivacyCollectionYn = watch('agreePrivacyCollectionYn', false);
  const marketingSmsConsentYn = watch('marketingSmsConsentYn', false);
  const marketingEmailConsentYn = watch('marketingEmailConsentYn', false);

  const isAllAgree =
    agreeTermsOfServiceYn && agreePrivacyCollectionYn && marketingSmsConsentYn && marketingEmailConsentYn;
  const isMarketingAgree = marketingSmsConsentYn || marketingEmailConsentYn;

  // 개인정보 동의 관련 내용 표시/미표시 상태 값
  const [isShowAllAgreeContent, setIsShowAllAgreeContent] = useState(false);
  const [isShowMarketingAgreeContent, setIsShowMarketingAgreeContent] = useState(false);

  const onChangeAllAgree = useCallback(() => {
    setValue('agreeTermsOfServiceYn', !isAllAgree);
    setValue('agreePrivacyCollectionYn', !isAllAgree);
    setValue('marketingSmsConsentYn', !isAllAgree);
    setValue('marketingEmailConsentYn', !isAllAgree);

    setIsShowAllAgreeContent(true);
    setIsShowMarketingAgreeContent(true);

    clearErrors(['agreeTermsOfServiceYn', 'agreePrivacyCollectionYn']);
  }, [isAllAgree]);

  const onClickShowAgreeContent = useCallback(() => {
    setIsShowAllAgreeContent(!isShowAllAgreeContent);
  }, [isShowAllAgreeContent]);

  const onChangeMarketingAgree = useCallback(() => {
    setValue('marketingSmsConsentYn', !isMarketingAgree);
    setValue('marketingEmailConsentYn', !isMarketingAgree);

    setIsShowMarketingAgreeContent(true);
  }, [isMarketingAgree]);

  const onClickShowMarketingAgreeContent = useCallback(() => {
    setIsShowMarketingAgreeContent(!isShowMarketingAgreeContent);
  }, [isShowMarketingAgreeContent]);

  return (
    <Element name={'agreeArea'} className={cx('termsArea')}>
      <div className={cx('agreeArea')}>
        <div className={cx('agreeWrap')}>
          <label className={cx('label')}>
            <input type="checkbox" className={cx('input', 'hidden')} checked={isAllAgree} onChange={onChangeAllAgree} />
            <span className={cx('checkbox')} />
            모든 약관 사항에 전체 동의합니다.
          </label>
          {(errors.agreeTermsOfServiceYn || errors.agreePrivacyCollectionYn) && (
            <div className={cx('infoText', 'error')}>{ERROR_TEXT.TERMS_AGREE}</div>
          )}
        </div>
        <button type="button" className={cx('btnExtend')} onClick={onClickShowAgreeContent}>
          {isShowAllAgreeContent ? (
            <Icon name="largeArrowTopLight" width={32} height={32} />
          ) : (
            <Icon name="largeArrowBottomLight" width={32} height={32} />
          )}
        </button>
      </div>

      <ul className={cx('termsList', { hidden: !isShowAllAgreeContent })}>
        <AgreeListItem
          name={'agreeTermsOfServiceYn'}
          title={'서비스 이용약관 동의 (필수)'}
          isRequired={true}
          detailLink={RouteUrl.TERMS_OF_SERVICE}
        />
        <AgreeListItem
          name={'agreePrivacyCollectionYn'}
          title={'개인정보 수집 및 이용 동의 (필수)'}
          isRequired={true}
          detailLink={RouteUrl.PRIVACY_COLLECTION}
        />
        <li className={cx('listItem')}>
          <div className={cx('labelWrap', 'withChildList')}>
            <div className={cx('labelWrap')}>
              <label className={cx('label')}>
                <input
                  {...register('marketingConsentYn', valueNotRequired)}
                  type="checkbox"
                  className={cx('input', 'hidden')}
                  checked={isMarketingAgree}
                  onChange={onChangeMarketingAgree}
                />
                <span className={cx('checkbox')} />
                마케팅 정보 수신 동의 (선택)
              </label>
              <button
                type="button"
                className={cx('btnExtend', { on: isShowMarketingAgreeContent })}
                onClick={onClickShowMarketingAgreeContent}
              >
                {isShowMarketingAgreeContent ? (
                  <Icon name="largeArrowTopLight" width={24} height={24} />
                ) : (
                  <Icon name="largeArrowBottomLight" width={24} height={24} />
                )}
              </button>
            </div>
            <a href={RouteUrl.MARKETING_POLICY} className={cx('link')} target="_blank" rel="noreferrer">
              자세히
            </a>
          </div>
          <ul className={cx('termsList', { hidden: !isShowMarketingAgreeContent })}>
            <AgreeMarketingListItem name={'marketingSmsConsentYn'} title={'SMS 수신 동의'} isRequired={false} />
            <AgreeMarketingListItem name={'marketingEmailConsentYn'} title={'이메일 수신 동의'} isRequired={false} />
          </ul>
        </li>
      </ul>
    </Element>
  );
};

export default Agree;
